import React from 'react'

import classes from './loading-dots-center.module.scss'
import { LoadingDots } from '../loading-dots'

export const LoadingDotsCenter = () => (
  <div className={classes.container} data-testid="loading-dots-center">
    <LoadingDots />
  </div>
)

export default LoadingDotsCenter
